module.exports = __webpack_public_path__ + "static/media/wellbeing manager.4663b027.svg";